export default {
	noDataText: "No data available",
	loading: "Loading...",
};
